export default __webpack_public_path__ + "static/media/bas_02-1.b8699191.jpg";